<template>
  <layout-basic>
    <profile-layout>
      <v-data-table
        :headers="headers"
        :options.sync="options"
        :server-items-length="serverItemsLength"
        :loading="loading"
        :items="channels"
      >
        <template v-slot:item.id="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="secondary"
                small
                class="ml-1"
                :to="'/playlist/details/' + item.id"
                outlined
              >
                <v-icon small>fa-search</v-icon>
              </v-btn>
            </template>
            <span>View Playlist</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </profile-layout>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
import ProfileLayout from "@/layouts/Profile";
import userAPI from "@/api/user.js";

export default {
  name: "Profile",
  components: {
    LayoutBasic,
    ProfileLayout
  },
  data() {
    return {
      headers: [
        { text: "Playlist Name", value: "name" },
        { text: "Modules", value: "total_modules" },
        //{ text: "Modules Completed", value: null },
        //{ text: "Progress", value: null },
        { text: "", value: "id", align: "end" }
      ],
      channels: [],
      loading: false,
      pagination: {},
      options: {}
    };
  },
  computed: {
    serverItemsLength: function() {
      return this.pagination.total;
    },
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.options);
    }
  },
  watch: {
    options: {
      handler() {
        this.getChannels();
      },
      deep: true
    }
  },
  mounted() {
    //this.getChannels();
  },
  methods: {
    //updatePagination(p) {
    //  this.params = this.$gf.getQueryString(p);
    //  this.getChannels();
    //},
    getChannels() {
      this.loading = true;
      userAPI.getChannels(this.params).then(response => {
        this.loading = false;
        this.channels = response.data.data;
      });
    }
  }
};
</script>
